module.exports = __webpack_public_path__ + "static/media/burger.a91cf3de.svg";